import React from "react";
import { RxGlobe } from "react-icons/rx";
import { MdKeyboardArrowDown } from "react-icons/md";
import { MdCopyright } from "react-icons/md";
import { FaFacebook, FaTwitter, FaPinterest } from "react-icons/fa";
import facebook from "../assets/icons/facebook.png";
import twitter from "../assets/icons/twitter.png";
import pinterest from "../assets/icons/pinterest.png";
import instagram from "../assets/icons/instagram.png";
import { useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import logo from "../assets/resume/logo.png";

const Footer = () => {
  const isLang = useSelector((state) => state.authReducer.lang);

  return (
    <>
      {isLang === "eng" ? (
        <div className="grid grid-cols-1 px-4 gap-2 md:px-10 lg:px-20 sm:grid-cols-3 md:grid-cols-10 py-16 border-t-2 border-b-2 text-black lg:grid-cols-10">
          <div className="flex flex-col gap-2 col-span-4">
            <NavLink to="/" className="focus:outline-none">
              <img src={logo} className="cursor-pointer w-[200px] h-14" alt="Logo" />
            </NavLink>
            <p className="text-[15px] font-[400] md:mr-10 sm:mr-10 lg:mr-10 xl:mr-10 text-justify">
              Maker4U is your All-in-one solution for creating magnetic promotional products, flawless editing, and stunning results that can spark your brand identification online. Stand out with polished, high-quality templates designed by experts.
            </p>
          </div>
          <div className="flex flex-col gap-2 col-span-2">
            <p className="text-[20px] font-[600]">Company</p>
            <NavLink to={`/AboutUs`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">About Us</p>
            </NavLink>
            <NavLink to={`/PrivacyPolicy`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Privacy Policy</p>
            </NavLink>
            <NavLink to={`/TermsCondition`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Terms & Conditions</p>
            </NavLink>
            <NavLink to={`/ContactusPage`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Contact Us</p>
            </NavLink>
            <a href="/BecomePartener" className="hover:no-underline">
              <p className="text-[15px] font-[400]">Become a Partner</p>
            </a>
          </div>

          <div className="flex flex-col gap-2 col-span-2">
            <p className="text-[20px] font-[600]">Explore</p>
            <NavLink to={`/catelog`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Promotion Maker</p>
            </NavLink>
            <NavLink to={`/ResumeMaker`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Resume Maker</p>
            </NavLink>
            <NavLink to={`/LogoMaker`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Logo Maker</p>
            </NavLink>
            <NavLink to={`/CoverLetter`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Cover Letter</p>
            </NavLink>
            <NavLink to={`/EmployeeCertificate`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Employee Certificates</p>
            </NavLink>
            <NavLink to={`/editor`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">Video Editor</p>
            </NavLink>
          </div>

          <div className="flex flex-col gap-2 col-span-2">
            <p className="text-[20px] font-[600]">Support</p>
            <a href={`/price`} className="hover:no-underline focus:outline-none">
              <p className="text-[15px] font-[400]">Pricing</p>
            </a>
            <p className="text-[15px] font-[400]">Email: info@maker4u.com</p>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 px-4 gap-2 md:px-10 lg:px-20 sm:grid-cols-2 md:grid-cols-5 py-16 border-t-2 border-b-2 text-black" style={{ direction: "rtl" }}>
          <div className="flex flex-col gap-2 col-span-2">
            <NavLink to="/" className="focus:outline-none">
              <img src={logo} className="cursor-pointer w-[200px] h-14" alt="Logo" />
            </NavLink>
            <p className="text-[15px] font-[400] text-right">
              Maker4U هو حل شامل لإنشاء منتجات ترويجية جذابة، وتحرير خالٍ من العيوب، ونتائج مذهلة يمكن أن تثير تحديد علامتك التجارية عبر الإنترنت. تميز باستخدام قوالب مصقولة وعالية الجودة مصممة من قبل الخبراء.
            </p>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-[24px] font-[700]">شركة</p>
            <NavLink to={`/AboutUs`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">عن</p>
            </NavLink>
            <NavLink to={`/PrivacyPolicy`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">حماية</p>
            </NavLink>
            <NavLink to={`/TermsCondition`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">الشروط والخصوصية</p>
            </NavLink>
            <NavLink to={`/ContactusPage`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">اتصل بنا</p>
            </NavLink>
            <a href="/BecomePartener" className="hover:no-underline">
              <p className="text-[15px] font-[400]">كن شريكاً</p>
            </a>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-[24px] font-[700]">استكشاف</p>
            <NavLink to={`/catelog`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">صانع الترويج</p>
            </NavLink>
            <NavLink to={`/ResumeMaker`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">صانع السيرة الذاتية</p>
            </NavLink>
            <NavLink to={`/LogoMaker`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">صانع الشعار</p>
            </NavLink>
            <NavLink to={`/CoverLetter`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">خطاب التغطية</p>
            </NavLink>
            <NavLink to={`/EmployeeCertificate`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">شهادات الموظفين</p>
            </NavLink>
            <NavLink to={`/editor`} className="hover:no-underline">
              <p className="text-[15px] font-[400]">محرر الفيديو</p>
            </NavLink>
          </div>
          <div className="flex flex-col gap-2">
            <p className="text-[24px] font-[700]">دعم</p>
            <a href={`/price`} className="hover:no-underline focus:outline-none">
              <p className="text-[15px] font-[400]">الأسعار</p>
            </a>
            <p className="text-[15px] font-[400]">البريد الإلكتروني: info@maker4u.com</p>
          </div>
        </div>
      )}

      <div className="flex justify-around items-center flex-wrap-reverse p-8 gap-6 text-black">
        <div className="flex items-center gap-1 border-2 p-2">
          <RxGlobe className="text-[25px]" />
          <p>{isLang === "eng" ? "English (United States)" : "العربية"}</p>
          <MdKeyboardArrowDown className="text-[25px]" />
        </div>
        <div className="text-center">
          <div className="flex items-center gap-1">
            <MdCopyright />
            <p>{isLang === "eng" ? "2024 All Rights Reserved" : "2024 جميع الحقوق محفوظة"}</p>
          </div>
          <p>{isLang === "eng" ? "Privacy Policy | Terms" : "سياسة الخصوصية | الشروط"}</p>
        </div>
        <div className="flex gap-[6px] w-[250px] justify-center">
          <img src={facebook} className="h-8 w-8" alt="Facebook" />
          <img src={twitter} className="h-8 w-8" alt="Twitter" />
          <img src={pinterest} className="h-8 w-8" alt="Pinterest" />
          <img src={instagram} className="h-8 w-8" alt="Instagram" />
        </div>
      </div>
    </>
  );
};

export default Footer;
